import React from 'react';
import { TextInputPropsBase } from './TextInput';

type TextAreaInputProps = TextInputPropsBase & React.TextareaHTMLAttributes<HTMLTextAreaElement>;

const BORDER = '#D9D9D9';

export function TextAreaInput(props: TextAreaInputProps) {
  const { error, ...rest } = props;

  const errored = (error?.length ?? 0) > 0;

  return (
    <div className="w-full">
      <textarea
        {...rest}
        className={`w-full rounded-lg border px-3 py-2 text-sm ${props.className || ''} ${
          errored ? 'border-error' : ''
        }`}
        style={{
          borderColor: errored ? undefined : BORDER,
          color: 'black',
          width: '100%',
          ...(props.style || {}),
        }}
      />
      {errored && <div className="text-error text-xs">{props.error}</div>}
    </div>
  );
}
